import { DendromapLoader } from '@repo/ui/components/dendromap-loader';
import { lazy, Suspense } from 'react';
import { DashboardLayout } from '@repo/ui/components/dashboard-layout';

const InventaireManagement = lazy(() =>
  import('@repo/ui/features/inventaires/InventaireManagement').then((mod) => ({
    default: mod.InventaireManagement,
  })),
);

export default function InventairesPage() {
  return (

    <Suspense fallback={<DendromapLoader message="Chargement des inventaires..." />}>
      <InventaireManagement />
    </Suspense>

  );
}

